/**
 * `cn` — the one class-concatenator every UI component uses.
 *
 * Wraps `clsx` (conditional joining) with `tailwind-merge` (dedupe + win
 * logic for conflicting Tailwind classes).  Callers pass `className` and
 * it just works:
 *
 *     <Button className="h-12 bg-red-500" />      // overrides component defaults
 *     <Card className={cn('border-red-500', isError && 'border-red-700')} />
 */
import { type ClassValue, clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
